import Modal from '@/components/Modal'
import { Button } from 'antd'
import { ReactComponent as TxSuccessIcon } from '@/assets/icons/txSuccess.svg'
import styles from './index.module.scss'
import i18n from '@/services/i18n'

const open = () => {
  const modal = Modal.info({
    width: 335,
    title: i18n.t('wallet.sendDrawer.txSendSuccessTitle'),
    icon: null,
    wrapClassName: styles.container,
    content: (
      <div className={styles.content}>
        <TxSuccessIcon />
        <p>{i18n.t('wallet.sendDrawer.txSendSuccessDesc')}</p>
        <Button type="primary" onClick={() => modal.destroy()}>
          {i18n.t('wallet.sendDrawer.txSendSuccessOk')}
        </Button>
      </div>
    ),
    footer: null,
  })
}

export default {
  open,
}
